export const getFormattedImages = (imagesData) => {
  const imagesArr = [];
  imagesData.filter((item) => {
    const imagePath = item.image.substring(item.image.indexOf("public"));
    const obj = {
      image: imagePath,
      copyRight: item.copyRight,
      copyRightText: item.copyRightText,
      shareImage: item.shareImage,
    };
    imagesArr.push(obj);
  });
  return imagesArr;
};
export const storyChangeValidations = (story, contentSelectedLangVal) => {
  const sTitle = story && story[`storyTitle_${contentSelectedLangVal}`] != "";
  const sDescription =
    story && story[`storyCardDescription_${contentSelectedLangVal}`] != "";
  const sImages = story.storyCardImages && story.storyCardImages.length > 0;
  return sTitle || sDescription || sImages;
};
export const mcqChangeValidations = (mcq, contentSelectedLangVal) => {
  const mcqTitle = mcq && mcq[`mcqTitle_${contentSelectedLangVal}`] != "";
  const ansExplanation =
    mcq && mcq[`answerExplanation_${contentSelectedLangVal}`] != "";
  const mcqImages = mcq.mcqImages && mcq.mcqImages.length > 0;
  const mcqCardImages = mcq.mcqCardImages && mcq.mcqCardImages.length > 0;
  const answersInfo = mcq.answersInfo && mcq.answersInfo.length > 0;
  const textValidations = mcqTitle || ansExplanation || answersInfo;
  const imageValidations = mcqImages || mcqCardImages;
  return textValidations || imageValidations;
};
export const inAppBrowserChangeValidation = (
  inAppBrowser,
  contentSelectedLangVal
) => {
  const inAppTitle =
    inAppBrowser &&
    inAppBrowser[`coverStoryTitle_${contentSelectedLangVal}`] != "";
  const inAppImages =
    inAppBrowser.coverStoryImages && inAppBrowser.coverStoryImages.length > 0;
  const inAppLink = inAppBrowser.link && inAppBrowser.link != "";
  const inAppLinkText = inAppBrowser.linkText && inAppBrowser.linkText != "";
  const inAppTitleOptions =
    inAppBrowser.textColor ||
    inAppBrowser.backGroundTitle ||
    inAppBrowser.contentTitlePosition;
  const textValidations = inAppTitle || inAppLink || inAppLinkText;
  const imageValidations = inAppImages;
  return textValidations || imageValidations || inAppTitleOptions;
};

export const fsValidation = (flipToStory, contentSelectedLangVal) => {
  const fsTitle =
    flipToStory &&
    flipToStory[`coverStoryTitle_${contentSelectedLangVal}`] != "";
  const fsCardDesc =
    flipToStory &&
    flipToStory[`coverStoryCardDescription_${contentSelectedLangVal}`] != "";
  const fsImages =
    flipToStory.coverStoryImages && flipToStory.coverStoryImages.length > 0;
  const fsCardImages =
    flipToStory.coverStoryCardImages && flipToStory.coverStoryCardImages != "";
  const fsTitleOptions =
    flipToStory.textColor ||
    flipToStory.backGroundTitle ||
    flipToStory.contentTitlePosition;
  const textValidations = fsTitle || fsCardDesc || fsTitleOptions;
  const imageValidations = fsImages || fsCardImages;
  return textValidations || imageValidations;
};
export const onlyCoverValidation = (onlyCover, contentSelectedLangVal) => {
  const csTitle =
    onlyCover && onlyCover[`coverStoryTitle_${contentSelectedLangVal}`] != "";
  const csCardDesc =
    onlyCover &&
    onlyCover[`coverStoryCardDescription_${contentSelectedLangVal}`] != "";
  const csImages =
    onlyCover.coverStoryImages && onlyCover.coverStoryImages.length > 0;
  const csTitleOptions =
    onlyCover.textColor ||
    onlyCover.backGroundTitle ||
    onlyCover.contentTitlePosition;
  const textValidations = csTitle || csCardDesc;

  return textValidations || csImages || csTitleOptions;
};
export const pollInfoValidation = (pollInfo, contentSelectedLangVal) => {
  const pollChoiceEmpty =
    pollInfo &&
    pollInfo.filter((choice) => {
      if (choice[`choice_${contentSelectedLangVal}`] == "") {
        return true;
      }
    });
  const pollChoiceChoosen =
    pollInfo &&
    pollInfo.filter((choice) => {
      if (choice.votes >= 0) {
        return true;
      }
    });
  const pollChoiceEmptyLength = pollChoiceEmpty && pollChoiceEmpty.length;
  const pollChoiceChoosenLength = pollChoiceChoosen && pollChoiceChoosen.length;
  if (pollChoiceEmptyLength == 0 && pollChoiceChoosenLength >= 1) {
    return true;
  }
  return false;
};
export const answersInfoValidation = (answersInfo, contentSelectedLangVal) => {
  const answerTextEmpty =
    answersInfo &&
    answersInfo.filter((answer) => {
      if (answer[`answer_${contentSelectedLangVal}`] == "") {
        return true;
      }
    });
  const correctAnswerChoosen =
    answersInfo &&
    answersInfo.filter((answer) => {
      if (answer.correct == "true") {
        return true;
      }
    });
  const ansTextEmptyLength = answerTextEmpty && answerTextEmpty.length;
  const correctAnsChoosenLength =
    correctAnswerChoosen && correctAnswerChoosen.length;
  if (ansTextEmptyLength == 0 && correctAnsChoosenLength >= 1) {
    return true;
  }
  return false;
};
export const getWordpressCategoryIds = (wordPressInfo) => {
  let catIds = [];
  if (wordPressInfo.wordPressContentCategory1ID) {
    catIds.push(wordPressInfo.wordPressContentCategory1ID);
  }
  if (wordPressInfo.wordPressContentCategory2ID) {
    catIds.push(wordPressInfo.wordPressContentCategory2ID);
  }
  if (wordPressInfo.wordPressContentCategory3ID) {
    catIds.push(wordPressInfo.wordPressContentCategory3ID);
  }
  return catIds;
};
export const getSelectedItem = (selectedCategory) => {
  const contentCategories = selectedCategory.split("->");
  const categoryData = contentCategories[0] ? contentCategories[0] : "";
  const levelData = contentCategories[1] ? "->" + contentCategories[1] : "";
  const sublevelData = contentCategories[2] ? "->" + contentCategories[2] : "";
  const selectedItem = categoryData + levelData + sublevelData;
  return selectedItem;
};
export const getEditContentSelectedCategory = (contentDetails) => {
  const categoryData = contentDetails.contentCategory1
    ? contentDetails.contentCategory1
    : "";
  const levelData = contentDetails.contentCategory2
    ? categoryData
      ? "->" + contentDetails.contentCategory2
      : contentDetails.contentCategory2
    : "";
  const sublevelData = contentDetails.contentCategory3
    ? levelData
      ? "->" + contentDetails.contentCategory3
      : contentDetails.contentCategory3
    : "";
  let selectedItem = "";
  if (categoryData) {
    selectedItem = selectedItem + categoryData;
  }
  if (levelData) {
    selectedItem = selectedItem + levelData;
  }
  if (sublevelData) {
    selectedItem = selectedItem + sublevelData;
  }
  return selectedItem;
};
export const getSelectedDate = (days) => {
  switch (days) {
    case "None":
      return {
        value: "None",
        days: 0,
        id: 1,
      };

    case "4 Hours":
      return {
        value: "4 Hours",
        hours: 4,
        id: 2,
      };
    case "8 Hours":
      return {
        value: "8 Hours",
        hours: 8,
        id: 3,
      };
    case "12 Hours":
      return {
        value: "12 Hours",
        hours: 12,
        id: 4,
      };
    case "1 Day":
      return {
        value: "1 Day",
        days: 1,
        id: 5,
      };

    case "3 Days":
      return {
        value: "3 Days",
        days: 3,
        id: 6,
      };
    case "1 Week":
      return {
        value: "1 Week",
        days: 7,
        id: 7,
      };
    case "1 Month":
      return {
        value: "1 Month",
        days: 30,

        id: 8,
      };
    default:
      return {
        value: "None",
        days: 0,
        id: 1,
      };
  }
};
export const StickyPostValidations = (
  stickyPost,
  stickyEndDateTime,
  showSticky,
  stickyTargetImpressions,
  positionFromTop,
  pushRankTo,
  pushRankUpTo
) => {
  let stickyPostPositionValidations = true;
  let stickyPostEndDateTimeValidations = true;
  let stickyTargetImpressionsValidations = true;
  let stickyPostPushRankToValidations = true;
  let stickyPostPushRankUpToValidations = true;
  if (stickyPost) {
    if (positionFromTop != "") {
      stickyPostPositionValidations = true;
    } else {
      stickyPostPositionValidations = false;
    }
    if (pushRankTo != "") {
      stickyPostPushRankToValidations = true;
    } else {
      stickyPostPushRankToValidations = false;
    }
    if (pushRankUpTo != "") {
      stickyPostPushRankUpToValidations = true;
    } else {
      stickyPostPushRankUpToValidations = false;
    }
    if (showSticky == "stickyNoOfTimes" && stickyTargetImpressions == "") {
      stickyTargetImpressionsValidations = false;
    } else {
      stickyTargetImpressionsValidations = true;
    }

    const stickyEndDateTimeStamp = new Date(stickyEndDateTime).getTime();
    const PresentDateTimeStamp = new Date().getTime();
    if (parseInt(stickyEndDateTimeStamp) - parseInt(PresentDateTimeStamp) > 0) {
      stickyPostEndDateTimeValidations = true;
    } else {
      stickyPostEndDateTimeValidations = false;
    }
  }
  return (
    stickyPostPositionValidations &&
    stickyPostEndDateTimeValidations &&
    stickyTargetImpressionsValidations &&
    stickyPostPushRankToValidations
  );
};
export const InAppMessageValidations = (
  stickyPost,
  isInAppMessage,
  inAppMessageDetails
) => {
  let campaignTargetImpressionsValidation = true;
  let campaignDateTimeValidations = true;
  const campaignPositionAvailable = inAppMessageDetails?.campaignPosition;
  let campaignPositionValidations =
    isInAppMessage && !stickyPost
      ? campaignPositionAvailable
        ? true
        : false
      : true;
  let campaignTargetImpressionsPerUserValidation = true;
  let campaignTIPUGTTIValidation = true;
  if (
    isInAppMessage &&
    !stickyPost &&
    Object.keys(inAppMessageDetails).length > 0
  ) {
    if (isNaN(inAppMessageDetails.campaignPosition)) {
      campaignPositionValidations = false;
    } else {
      campaignPositionValidations = true;
    }

    if (inAppMessageDetails.noOfTimes == "campaignNoOfTimes") {
      if (isNaN(inAppMessageDetails.campaignTargetImpressions)) {
        campaignTargetImpressionsValidation = false;
      }
      if (isNaN(inAppMessageDetails.campaignTargetImpressionsPerUser)) {
        campaignTargetImpressionsPerUserValidation = false;
      }
      if (
        inAppMessageDetails.campaignTargetImpressionsPerUser >
        inAppMessageDetails.campaignTargetImpressions
      ) {
        campaignTIPUGTTIValidation = false;
      }
    } else {
      campaignTargetImpressionsValidation = true;
      campaignTargetImpressionsPerUserValidation = true;
      campaignTIPUGTTIValidation = true;
    }
    const campaignStartDateTimeStamp = new Date(
      inAppMessageDetails.campaignStartDateTime
    ).getTime();
    const campaignEndDateTimeStamp = new Date(
      inAppMessageDetails.campaignEndDateTime
    ).getTime();
    if (campaignEndDateTimeStamp - campaignStartDateTimeStamp > 0) {
      campaignDateTimeValidations = true;
    } else {
      campaignDateTimeValidations = false;
    }
  }

  return (
    campaignTargetImpressionsValidation &&
    campaignDateTimeValidations &&
    campaignPositionValidations &&
    campaignTargetImpressionsPerUserValidation &&
    campaignTIPUGTTIValidation
  );
};
export const GetStoryCotentData = (
  data,
  storyCardImages,
  storyYoutubeImages
) => {
  let images =
    storyCardImages && storyCardImages.length > 0
      ? storyCardImages
      : storyYoutubeImages
      ? storyYoutubeImages
      : [];
  const imagesArr = [];
  images.filter((item) => {
    const obj = {
      image: item.image,
      imageValue: item.imageValue,
      copyRight: item.copyRightText == "Movies" ? true : item.copyRight,
      copyRightText: item.copyRightText,
      shareImage: item.shareImage,
    };
    imagesArr.push(obj);
  });
  const finalImages = imagesArr;
  if (storyCardImages && storyCardImages.length > 0) {
    data["storyCardImages"] = finalImages;
  }
  if (storyYoutubeImages && storyYoutubeImages.length > 0) {
    data["storyYoutubeImages"] = finalImages;
  }
  return data;
};
export const GetLiveNewsContentData = (
  data,
  liveNewsImages,
  liveNewsYoutubeImages
) => {
  let images =
    liveNewsImages && liveNewsImages.length > 0
      ? liveNewsImages
      : liveNewsYoutubeImages
      ? liveNewsYoutubeImages
      : [];
  const imagesArr = [];
  images.filter((item) => {
    const obj = {
      image: item.image,
      imageValue: item.imageValue,
      copyRight: item.copyRightText == "Movies" ? true : item.copyRight,
      copyRightText: item.copyRightText,
      shareImage: item.shareImage,
    };
    imagesArr.push(obj);
  });
  const finalImages = imagesArr;
  if (liveNewsImages && liveNewsImages.length > 0) {
    data["liveNewsImages"] = finalImages;
  }
  if (liveNewsYoutubeImages && liveNewsYoutubeImages.length > 0) {
    data["liveNewsYoutubeImages"] = finalImages;
  }
  return data;
};
export const GetWordPressInfo = (duplicateContent, wordPressInfo) => {
  let info = wordPressInfo;
  if (duplicateContent) {
    const itemsToDelete = [
      "wordPressGalleryIDs",
      "isContentEditedInWordPress",
      "wordPressMediaID",
      "wordPressID",
      "wordPressTagIDs",
      "wordPressPostURL",
      "wordPressPostStatus",
    ];
    Object.keys(wordPressInfo).map((item, index) => {
      if (itemsToDelete.includes(item)) {
        delete info[item];
      }
    });
  }
  return info;
};
export const GetSlideShowPagesData = (preview, slideShowPages) => {
  slideShowPages &&
    slideShowPages.map((page) => {
      delete page.id;
      delete page.__typename;
      if (page.pageType == "Story") {
        !preview && delete page.storyDetails.storyCardOriginalImages;
        const imagesArr = [];
        page.storyDetails.storyCardImages.filter((item) => {
          const image = preview
            ? item.image
              ? item.image
              : item.key
            : item.image
            ? item.image.substring(item.image.indexOf("public"))
            : item.key;
          const obj = {
            image: image,
            imageValue: item.imageValue,
            copyRight: item.image ? item.copyRight : item.copyRight,
            copyRightText: item.copyRightText,
            shareImage: item.shareImage,
          };
          imagesArr.push(obj);
        });
        page.storyDetails.storyCardImages = imagesArr;
      } else if (page.pageType == "CoverStory") {
        !preview &&
          delete page.coverStoryDetails.onlyCoverDetails
            .coverStoryOriginalImages;
        const imagesArr = [];
        page.coverStoryDetails.onlyCoverDetails.coverStoryImages.filter(
          (item) => {
            const image = preview
              ? item.image
                ? item.image
                : item.key
              : item.image
              ? item.image.substring(item.image.indexOf("public"))
              : item.key;
            const obj = {
              image: image,
              imageValue: item.imageValue,
              copyRight: item.image ? item.copyRight : item.copyRight,
              copyRightText: item.copyRightText,
              shareImage: item.shareImage,
            };
            imagesArr.push(obj);
          }
        );
        page.coverStoryDetails.onlyCoverDetails.coverStoryImages = imagesArr;
      }
    });
  return slideShowPages;
};
export const GetCoverStoryType = (editContent, contentDetails) => {
  let coverStoryType = "";
  if (editContent) {
    const { coverStoryDetails } =
      contentDetails && contentDetails.contentMetaInfo;
    coverStoryType = coverStoryDetails && coverStoryDetails.coverStoryType;
  }
  return coverStoryType;
};

export const GetDate = () => {
  return (
    new Date().getFullYear() +
    "" +
    ("0" + (new Date().getMonth() + 1)).slice(-2) +
    ("0" + new Date().getDate()).slice(-2)
  );
};

export const ExtractMDLabels = (val) => {
  const regexMdLinks = /\[([^\]]*)\]\(([^)]*)\)/g;
  let updatedLinks = [];
  if (val) {
    const matches = val.match(regexMdLinks);
    const singleMatch = /\[([^\[]+)\]\((.*)\)/;
    matches?.map((item, index) => {
      let text = singleMatch.exec(matches[index]);
      if (text) {
        updatedLinks.push(text[1]);
      }
    });
  }
  return updatedLinks;
};
